import { createContext, useEffect, useState } from "react";
import { LayoutProps } from "../common.interface";


export const RouteContext = createContext<any>('routeContext')


const RouteContextProvider=({children}:LayoutProps)=>{
    const [activePage, setActivePage] = useState("/");
    let path = window.location.pathname;


    useEffect(()=>{
        setActivePage(path);
       },[])
    

    return (
        <RouteContext.Provider value={{activePage,setActivePage}}>
            {children}
        </RouteContext.Provider>
    );
};

export default RouteContextProvider;